<template>
  <b-collapse :id="'accordion-'+keyID" accordion="my-accordion" role="tabpanel">
    <b-card-body>
      <b-card-text ><h4>{{ this.answer.answers[0].body }}</h4></b-card-text>
      <b-button @click="doCopy" variant="primary">Copy</b-button>
    </b-card-body>
  </b-collapse>
</template>

<script>
import { sendReport } from "./../../api/conection";
export default {
  name: "Answer",
  props: {
    keyID: {
      type: Number,
      default: 0
    },
    answer: {
      type: Object,
      default: {}
    }
  },
  methods: {
    doCopy: function() {
        const quest = this.answer;
      this.$copyText(quest.answers[0].body).then(
          function(e) {
          
          //alert('Copied')
          /*TODO hacer función que agregue reporte */
            const hoy = new Date();
          const body = {
            //date_time_local: `${hoy.getHours()}:${hoy.getMinutes()}:${hoy.getSeconds()}`,
            //date: `${hoy.getFullYear()}-${hoy.getMonth()}-${hoy.getDate()}`,
            //user_id: 3,
            question_id: quest.question_id,
            answer_id: quest.answers[0].answer_id
          };

          sendReport(body)
            .then(response => {              
              console.log(response.body);
            })
            .catch(err => {
              console.log(err);
            });
          //console.log(e);
        },
        function(e) {
          //alert('Can not copy')
          console.log(e);
        }
      );
    }
  },
  data() {
    return {};
  }
};
</script>